import gettingStarted from './pages/getting-started';
import platformOverview from './pages/platform-overview';
import intelligenceSearch from './pages/intelligence-search';
import intelligenceExtractor from './pages/intelligence-extractor';
import relationshipsGraph from './pages/relationships-graph';
import cases from './pages/cases';
import indicators from './pages/indicators';
import evidence from './pages/evidence';
import personasEngagement from './pages/personas-engagement';
import keyboardShortcuts from './pages/keyboard-shortcuts';
import rolesPermissions from './pages/roles-permissions';
import glossary from './pages/glossary';

export const WIKI_SECTIONS = [
  { id: 'start', title: 'Start here', icon: '🚀' },
  { id: 'intelligence', title: 'Intelligence', icon: '🔍' },
  { id: 'investigations', title: 'Investigations', icon: '🗂️' },
  { id: 'engagement', title: 'Engagement', icon: '🎭' },
  { id: 'reference', title: 'Reference', icon: '📖' },
];

const ALL_PAGES = [
  gettingStarted,
  platformOverview,
  intelligenceSearch,
  intelligenceExtractor,
  relationshipsGraph,
  cases,
  indicators,
  evidence,
  personasEngagement,
  keyboardShortcuts,
  rolesPermissions,
  glossary,
];

export const WIKI_PAGES = ALL_PAGES.sort((a, b) => {
  const sectionOrder = WIKI_SECTIONS.findIndex((s) => s.id === a.section)
    - WIKI_SECTIONS.findIndex((s) => s.id === b.section);
  if (sectionOrder !== 0) return sectionOrder;
  return a.order - b.order;
});

export const WIKI_PAGE_MAP = Object.fromEntries(WIKI_PAGES.map((page) => [page.slug, page]));

export function getWikiPage(slug) {
  return WIKI_PAGE_MAP[slug] || null;
}

export function getWikiSectionPages(sectionId) {
  return WIKI_PAGES.filter((page) => page.section === sectionId);
}

export function getAdjacentPages(slug) {
  const index = WIKI_PAGES.findIndex((page) => page.slug === slug);
  if (index < 0) return { prev: null, next: null };
  return {
    prev: index > 0 ? WIKI_PAGES[index - 1] : null,
    next: index < WIKI_PAGES.length - 1 ? WIKI_PAGES[index + 1] : null,
  };
}

export function extractHeadings(markdown) {
  const headings = [];
  markdown.split('\n').forEach((line) => {
    const match = line.match(/^(#{2,3})\s+(.+)$/);
    if (!match) return;
    const level = match[1].length;
    const text = match[2].replace(/\*\*/g, '').trim();
    const id = text
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-');
    headings.push({ level, text, id });
  });
  return headings;
}

export function searchWikiPages(query) {
  const q = query.trim().toLowerCase();
  if (!q) return WIKI_PAGES;

  return WIKI_PAGES.map((page) => {
    let score = 0;
    if (page.title.toLowerCase().includes(q)) score += 10;
    if (page.description?.toLowerCase().includes(q)) score += 6;
    if (page.tags?.some((tag) => tag.includes(q))) score += 4;
    if (page.body.toLowerCase().includes(q)) score += 2;
    return { page, score };
  })
    .filter((item) => item.score > 0)
    .sort((a, b) => b.score - a.score)
    .map((item) => item.page);
}

export const WIKI_COMMAND_ROUTES = WIKI_PAGES.map((page) => ({
  id: `docs-${page.slug}`,
  label: page.title,
  section: `Docs · ${WIKI_SECTIONS.find((s) => s.id === page.section)?.title || 'Wiki'}`,
  to: `/docs/${page.slug}`,
}));
